import script from "./AgGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./AgGrid.vue?vue&type=script&setup=true&lang=js"

import "./AgGrid.vue?vue&type=style&index=0&id=c0ae699a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0ae699a"]])

export default __exports__